<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <QuitButton content_1="您的意見記錄將不會被保留。" content_2="是否確認退出？"></QuitButton>
      <BackButton v-if="back_button" @click="goBack"></BackButton>
    </FabColumn>

    <ion-content>
      <div class="flow-content">
        <MainTitle text="問卷調查" margin_top="short"></MainTitle>
  <!--      <MainSubtitle text=""></MainSubtitle>-->

        <div v-if="show_finish_type">
          <MainSubtitle class="sub-title" text="您覺得自己是否能夠順利獨自完成這個測試？"></MainSubtitle>
  <!--        <MainDescribe text="您覺得自己是否能夠順利獨自完成這個測試？"></MainDescribe>-->
          <SurveyFinishType @getFinishType="getFinishType"></SurveyFinishType>
        </div>

        <div v-if="show_test_again">
          <MainSubtitle class="sub-title" text="若有機會，您會否在一年後再進行此測試？"></MainSubtitle>
  <!--        <MainDescribe text="若有機會，您會否一年後有興趣再進行此測試？"></MainDescribe>-->
          <SurveyTestAgain @getTestAgain="getTestAgain"></SurveyTestAgain>
        </div>
        <ConfirmButton v-if="finish_type_confirm && show_finish_type" class="flow-confirm-button" text="確定" position="relative" @click="showTestAgain"></ConfirmButton>
        <ConfirmButton v-if="test_again_confirm && show_test_again" class="flow-confirm-button" text="確定" position="relative" @click="submitSurvey"></ConfirmButton>
        <TestNumber :number="user_info.number"></TestNumber>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {IonContent, IonPage} from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import MainTitle from "../components/common/MainTitle";
import ConfirmButton from "../components/common/ConfirmButton";
import SurveyTestAgain from "../components/survey/SurveyTestAgain";
import SurveyFinishType from "../components/survey/SurveyFinishType";
import common from "../common";
import router from "../router";
import QuitButton from "../components/common/QuitButton";
import MainSubtitle from "../components/common/MainSubtitle";
import BackButton from "../components/common/BackButton";
import TestNumber from "../components/test/TestNumber";

export default {
  name: "Survey",
  components: {
    TestNumber,
    BackButton,
    MainSubtitle,
    QuitButton,
    SurveyFinishType,
    SurveyTestAgain,
    ConfirmButton,
    MainTitle,
    WhiteBackground,
    Background,
    IonPage,
    IonContent,
  },
  data() {
    return {
      user_info: {},
      test_id: 0,

      show_finish_type: false,
      show_test_again: false,
      finish_type_confirm: false,
      test_again_confirm: false,

      finish_type: 0,
      test_again: 0,

      audio: null,
      back_button: false,
      play_timeout: null,
    }
  },
  ionViewWillEnter(){
    common.initData(this);
    common.getUserInfo().then(user_info => {
      this.user_info = user_info;
    })
    common.getStorage('storage_test_id').then(test_id => {
      this.test_id = test_id;
    })

    this.showFinishType();
  },
  ionViewWillLeave(){
    if (this.audio) {
      this.audio.pause();
    }
    if (this.play_timeout) {
      clearTimeout(this.play_timeout)
    }
  },
  methods: {
    getFinishType: function (finish_type) {
      this.finish_type = finish_type;
      this.finish_type_confirm = true;
    },
    getTestAgain: function (test_again) {
      this.test_again = test_again;
      this.test_again_confirm = true;
    },
    showFinishType: function () {
      this.show_test_again = false;
      this.show_finish_type = true;
      this.playAudio(15)
      this.back_button = false;
      this.finish_type_confirm = false;
    },
    showTestAgain: function () {
      this.show_finish_type = false;
      this.show_test_again = true;
      this.playAudio(17)
      this.back_button = true;
      this.test_again_confirm = false;
    },
    submitSurvey: function () {
      const loading = common.showLoading();
      common.apiPostData('/survey', {
        user_id: this.user_info.id,
        test_id: this.test_id,
        finish_type: this.finish_type,
        test_again: this.test_again
      }, true, loading).then(res => {
        if (res === false) {
          return false;
        }
        router.replace('/surveyFinish')
      })
    },
    playAudio: function (id) {
      if (this.audio) {
        this.audio.pause();
      }
      if (this.play_timeout) {
        clearTimeout(this.play_timeout);
        this.play_timeout = null;
      }
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      this.play_timeout = setTimeout(function () {
        that.audio = new Audio(common.getVoice(id));
        that.audio.play();
      }, 2000);

    },
    goBack: function () {
      this.showFinishType();
    }
  }
}
</script>

<style scoped>
  .sub-title{
    font-size: var(--ecs-font-lg);
    margin-bottom: 1vh;
    color: black;
  }

  .flow-confirm-button :deep(.relative) {
    margin: clamp(0.75rem, 2vw, 1.25rem) auto 0;
  }
</style>
